import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Box, Divider, Flex, Menu, MenuButton, MenuItem, MenuList, mode, Text, useColorMode, useOutsideClick } from '@abb/uikit';
import { Settings03 } from '@abb/uikit/icons/outline/general';
import { User03 } from '@abb/uikit/icons/outline/users';
import Gleap from 'gleap';
import { useDependencies } from 'hooks';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import DownIcon from 'shared-components/icons/DownIcon';
import { ColorMode } from './color-mode';
import { Customers } from './customers';
import { Languages } from './languages';
import { Logout } from './logout';
export function UserSettings(param) {
    let { isLargerThanMd } = param;
    var _userData_customers, _userService_getProcessClaims, _userData_customers_, _userData_customers1;
    const push = useNavigate();
    const { t } = useTranslation('common');
    const { userService } = useDependencies();
    const [menu, setMenu] = useState(false);
    const userData = userService === null || userService === void 0 ? void 0 : userService.getUserData;
    const companyName = userData === null || userData === void 0 ? void 0 : (_userData_customers = userData.customers) === null || _userData_customers === void 0 ? void 0 : _userData_customers[0].name;
    const isDirector = userService === null || userService === void 0 ? void 0 : (_userService_getProcessClaims = userService.getProcessClaims) === null || _userService_getProcessClaims === void 0 ? void 0 : _userService_getProcessClaims.isDirector;
    const dropdownRef = useRef(null);
    useOutsideClick({
        ref: dropdownRef
    });
    useEffect(()=>{
        if (userData) {
            Gleap.identify(`${userData.id}`, {
                name: `${userData.firstName}`,
                phone: userData.mobileNumber,
                companyName: userData === null || userData === void 0 ? void 0 : userData.customers[0].name,
                customData: {
                    projectId: '37f9278a1d76db19b1e02311',
                    TIN: userData === null || userData === void 0 ? void 0 : userData.customers[0].tin
                }
            });
        }
    }, [
        userData
    ]);
    const handleNavigate = ()=>{
        push('/settings/info');
    };
    const handleNavigateUsers = ()=>{
        push(`/sections-user-info`);
    };
    const { colorMode } = useColorMode();
    return /*#__PURE__*/ _jsx(Box, {
        px: {
            base: 5,
            md: 0
        },
        pt: {
            base: 6,
            md: 0
        },
        children: /*#__PURE__*/ _jsxs(Menu, {
            closeOnSelect: false,
            onClose: ()=>setMenu(!menu),
            matchWidth: !isLargerThanMd,
            children: [
                /*#__PURE__*/ _jsx(MenuButton, {
                    onClick: ()=>setMenu(!menu),
                    cursor: "pointer",
                    width: {
                        base: '100%',
                        md: 'auto'
                    },
                    children: /*#__PURE__*/ _jsxs(Flex, {
                        alignItems: "center",
                        flexDirection: {
                            base: 'row-reverse',
                            md: 'row'
                        },
                        justifyContent: {
                            base: 'flex-end',
                            md: 'center'
                        },
                        marginLeft: {
                            base: 0,
                            md: 2
                        },
                        px: {
                            base: 4,
                            md: 0
                        },
                        py: {
                            base: 3,
                            md: 0
                        },
                        borderRadius: "xl",
                        position: "relative",
                        backgroundColor: {
                            base: 'rgba(255, 255, 255, 0.1)',
                            md: 'transparent'
                        },
                        gap: {
                            base: 3,
                            md: 2
                        },
                        children: [
                            /*#__PURE__*/ _jsxs(Flex, {
                                flexDirection: "column",
                                justifyContent: "center",
                                ml: "10px",
                                mr: 3,
                                alignItems: "flex-start",
                                order: {
                                    base: 2
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        maxW: "150px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        fontSize: "14px",
                                        fontWeight: 500,
                                        variant: "labelValue",
                                        color: {
                                            base: 'white',
                                            md: mode('#0A0B0D', '#FFFFFF')({
                                                colorMode
                                            })
                                        },
                                        children: companyName
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        fontSize: "12px",
                                        variant: "label",
                                        maxW: "150px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        color: {
                                            base: 'white',
                                            md: mode('#484A4F', '#C4C7CC')({
                                                colorMode
                                            })
                                        },
                                        children: userData === null || userData === void 0 ? void 0 : (_userData_customers1 = userData.customers) === null || _userData_customers1 === void 0 ? void 0 : (_userData_customers_ = _userData_customers1[0]) === null || _userData_customers_ === void 0 ? void 0 : _userData_customers_.customerId
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Avatar, {
                                h: "40px",
                                w: "40px",
                                name: userData === null || userData === void 0 ? void 0 : userData.customers[0].name
                            }),
                            /*#__PURE__*/ _jsx(DownIcon, {
                                transform: `rotate(${menu ? '180deg' : '0deg'})`,
                                order: {
                                    base: 1,
                                    md: '3'
                                },
                                marginLeft: {
                                    base: 'auto'
                                },
                                color: {
                                    base: 'white',
                                    md: mode('gray.700', 'white')({
                                        colorMode
                                    })
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs(MenuList, {
                    p: 1,
                    borderRadius: "24px",
                    width: "248px",
                    children: [
                        /*#__PURE__*/ _jsx(Customers, {}),
                        /*#__PURE__*/ _jsx(MenuItem, {
                            _hover: {
                                bg: mode('#FAFAFA', '#292B2E')({
                                    colorMode
                                })
                            },
                            borderRadius: "12px",
                            p: "12px",
                            children: /*#__PURE__*/ _jsx(ColorMode, {})
                        }),
                        /*#__PURE__*/ _jsx(MenuItem, {
                            p: "12px",
                            _hover: {
                                bg: mode('#FAFAFA', '#292B2E')({
                                    colorMode
                                })
                            },
                            borderRadius: "12px",
                            w: "100%",
                            cursor: "pointer",
                            children: /*#__PURE__*/ _jsx(Languages, {})
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            my: "2px",
                            px: 2,
                            children: /*#__PURE__*/ _jsx(Divider, {
                                color: mode('#8b96a93b', '#8b96a93b')({
                                    colorMode
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx(MenuItem, {
                            borderRadius: "12px",
                            _hover: {
                                bg: mode('#FAFAFA', '#292B2E')({
                                    colorMode
                                })
                            },
                            p: "12px",
                            icon: /*#__PURE__*/ _jsx(Settings03, {
                                color: mode('#2D3748', '#F0F0F0')({
                                    colorMode
                                }),
                                width: "18px",
                                height: "18px"
                            }),
                            onClick: handleNavigate,
                            children: /*#__PURE__*/ _jsxs(Text, {
                                color: mode('#2D3748', '#F0F0F0')({
                                    colorMode
                                }),
                                children: [
                                    " ",
                                    t('user_settings.settings')
                                ]
                            })
                        }),
                        isDirector && /*#__PURE__*/ _jsx(MenuItem, {
                            borderRadius: "12px",
                            _hover: {
                                bg: mode('#FAFAFA', '#292B2E')({
                                    colorMode
                                })
                            },
                            p: "12px",
                            icon: /*#__PURE__*/ _jsx(User03, {
                                width: "18px",
                                height: "18px"
                            }),
                            onClick: handleNavigateUsers,
                            children: /*#__PURE__*/ _jsxs(Flex, {
                                justifyContent: "space-between",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ _jsxs(Text, {
                                        color: mode('#2D3748', '#F0F0F0')({
                                            colorMode
                                        }),
                                        children: [
                                            " ",
                                            t('userInfo')
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        bg: "red",
                                        p: "4px",
                                        borderRadius: "100%"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(MenuItem, {
                            _hover: {
                                bg: 'none'
                            },
                            paddingLeft: 4,
                            width: "100%",
                            borderRadius: "12px",
                            p: "12px",
                            children: /*#__PURE__*/ _jsx(Logout, {})
                        })
                    ]
                })
            ]
        })
    });
}
